import { FileImage, Grid, Type, Monitor, Palette, Settings, Layout } from "lucide-react";
import { ImageDemo } from '../demos/ImageDemo';
import { PatternDemo } from '../demos/PatternDemo';
import { TypographyDemo } from '../demos/TypographyDemo';
import { UIDemo } from '../demos/UIDemo';
import { IllustrationDemo } from '../demos/IllustrationDemo';
import { GradientDemo } from '../demos/GradientDemo';
import { BrandDemo } from '../demos/BrandDemo';
import { VariationsDemo } from '../demos/VariationsDemo';
import { TemplatesDemo } from '../demos/TemplatesDemo';

const GradientIcon = (props) => (
    <svg {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="2" y="6" width="20" height="8" rx="1" />
        <path d="m2 12 20-6" />
        <path d="m2 12 20 6" />
    </svg>
);

const BrandIcon = (props) => (
    <svg {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="3" />
        <path d="M12 1v6m0 6v6" />
        <path d="m15.5 3.5-1.4 1.4m-4.2 4.2L8.5 20.5" />
        <path d="M21 12h-6m-6 0H3" />
        <path d="m20.5 8.5-1.4 1.4m-4.2 4.2L3.5 15.5" />
    </svg>
);

const VariationsIcon = (props) => (
    <svg {...props} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="3" />
        <circle cx="6" cy="6" r="2" />
        <circle cx="6" cy="18" r="2" />
        <circle cx="18" cy="6" r="2" />
        <circle cx="18" cy="18" r="2" />
        <path d="m8 8 8 8" />
        <path d="m16 8-8 8" />
    </svg>
);

export const tabs = [
    { id: "images", label: "Images", icon: FileImage, component: ImageDemo },
    { id: "patterns", label: "Patterns", icon: Grid, component: PatternDemo },
    { id: "typography", label: "Typography", icon: Type, component: TypographyDemo },
    { id: "ui", label: "UI", icon: Monitor, component: UIDemo },
    { id: "illustration", label: "Graphical Elements", icon: Palette, component: IllustrationDemo },
    { id: "gradients", label: "Gradients", icon: GradientIcon, component: GradientDemo },
    { id: "brand", label: "Brand", icon: BrandIcon, component: BrandDemo },
    { id: "variations", label: "Variations", icon: VariationsIcon, component: VariationsDemo },
    { id: "templates", label: "Templates", icon: Layout, component: TemplatesDemo },
];